import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar bg-dark text-white d-flex flex-column p-3" }
const _hoisted_2 = { class: "nav flex-column" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "mt-auto" }
const _hoisted_8 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-center" }, "MyApp", -1)),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "nav-link",
          to: "/"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Dashboard")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_4, [
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "nav-link",
              to: { name: 'Distributors' }
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Distributors")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", _hoisted_5, [
        (_ctx.isSuperAdmin || _ctx.isDistributor)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "nav-link",
              to: { name: 'Clients' }
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Clients")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", _hoisted_6, [
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "nav-link",
              to: "/users"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Users")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "small mb-1" }, "Logged in as:", -1)),
        _createElementVNode("strong", null, _toDisplayString(_ctx.authStore.user?.fullName), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
          class: "btn btn-outline-light btn-sm w-100 mt-2"
        }, "Logout")
      ])
    ])
  ]))
}